try {
    // window.Pace = Pace = require("pace-js");
    window.Swal = require('sweetalert2');
    window.Cookies = require("js-cookie");
} catch (e) {}
